import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { AiEnvironmentService } from '@azure/services';
import { environment } from 'environments/environment';

/** Lo único que viaja con ambiente: el catálogo y los agentes. */
const PATHS = [
  `${environment.azureApiUrl}/api/ai-registry`,
  `${environment.azureApiUrl}/api/ai-agents`,
];

/**
 * Agrega el ambiente elegido a las peticiones del módulo de IA. Va acá y no en
 * cada servicio para que no se olvide en ninguna, el borrado incluido.
 *
 * Sin ambiente elegido no agrega nada y el servidor usa el suyo por omisión.
 */
@Injectable()
export class AiEnvInterceptor implements HttpInterceptor {
  private _environments: AiEnvironmentService | null = null;

  /**
   * Se resuelve al vuelo y no por constructor: el servicio pide `HttpClient` y
   * `HttpClient` pide los interceptores, que es una dependencia cíclica.
   */
  constructor(private _injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!PATHS.some((path) => request.url.startsWith(path))) {
      return next.handle(request);
    }

    // Quien ya lo mandó explícitamente manda.
    if (request.params.has('env')) return next.handle(request);

    const env = this.service().current;
    if (!env) return next.handle(request);

    return next.handle(request.clone({ setParams: { env } }));
  }

  private service(): AiEnvironmentService {
    if (!this._environments) {
      this._environments = this._injector.get(AiEnvironmentService);
    }
    return this._environments;
  }
}
